<template>
  <div class="users">
    <!-- card -->
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>数据权限列表</span>
        <el-button
          class="tz-r tz-create-btn"
          type="primary"
          round
          @click="jump('/roleRights/create')"
          >添加</el-button
        >
      </div>
      <!-- card header -->

      <!-- card content -->
      <!-- 筛选 -->
      <!-- <el-row>
        <el-col :span="9">
          <el-input
            placeholder="请输入账号或用户姓名"
            v-model="params.uname"
            class="input-with-select"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="queryAllUserDataRight"
            ></el-button>
          </el-input>
        </el-col>
        <el-col :span="9">&nbsp;</el-col>
        <el-col :span="9">
          <el-date-picker
            v-model="params.date"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-col>
      </el-row> -->
      <!-- 筛选 -->

      <!-- 表格 -->
      <TzTable :tableData="allRoles" :columns="columns" />
      <!-- 表格 -->

      <!-- 分页 -->
      <!-- <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="params.pagenum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="allRoles.length"
      >
      </el-pagination> -->
      <!-- 分页 -->
      <!-- card content -->
    </el-card>
    <!-- card -->

    <!-- 编辑弹框 -->
    <Edit
      v-if="menus.length > 0"
      :state="editState"
      @close="editState = false"
      :role="editRole"
      :menus="menus"
      @confirm="changeRole"
    />
    <!-- 编辑弹框 end -->
  </div>
</template>

<script>
import TzTable from '@/components/tz-table/Index.vue'
import Edit from './components/Edit'
import { brequest } from '@/utils/brequest'
import { DASHBOARD_MODULE } from '@/utils/params'

export default {
  components: {
    TzTable,
    Edit
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
    },
    deleteFn(row) {
      console.log('删除2', row)

      this.$confirm('此操作将永久删除该数据权限, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.deleteDataRight(row)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    async deleteDataRight(dataRight) {
      this.$loading({
        text: '角色权限删除中'
      })
      let ret = await brequest({
        url: '/user/deleteRoleInfo',
        data: { id: dataRight.id }
      })
      this.$loading().close()
      if (ret) {
        this.$message({
          message: '角色权限删除成功',
          type: 'success'
        })
        this.queryAllMenus()
        this.queryAllRoles()
      }
    },

    async queryAllMenus() {
      let ret = await brequest({
        url: '/user/queryAllMenus'
      })
      this.menus = ret
        .filter((rec) => rec.parentId > 0)
        .map((rec) => {
          return {
            value: rec.id,
            label: rec.title
          }
        })
    },
    async queryAllRoles() {
      let ret = await brequest({
        url: '/user/queryAllRoles',
        data: { name: this.params.uname || '' }
      })
      this.allRoles = ret.map((rec) => {
        return {
          ...rec,
          menus: this.stringToIntArr(rec.menu),
          dashboard: this.stringToIntArr(rec.dashboardModule),
          menuTxt: this.queryMenuName(rec.menu),
          dashboardTxt: this.queryDashboardName(rec.dashboardModule)
        }
      })
    },
    stringToIntArr(str) {
      if (!str || str.trim() === '') return []
      let ret = str.split(',')
      for (let i = 0; i < ret.length; i++) {
        ret[i] = parseInt(ret[i])
      }
      return ret
    },
    queryMenuName(str) {
      if (!str) return ''
      let ret = str.split(',')
      console.log(this.menus, ret, '00000')
      for (let i = 0; i < ret.length; i++) {
        // ret[i] = this.menus.find((rec) => rec.value === parseInt(ret[i])).label
        let retFind = this.menus.find((rec) => rec.value === parseInt(ret[i]))
        if (retFind) {
          ret[i] = retFind.label
        }
      }
      return ret.join()
    },
    queryDashboardName(str) {
      if (!str) return ''
      let ret = str.split(',')
      for (let i = 0; i < ret.length; i++) {
        ret[i] = DASHBOARD_MODULE.find(
          (rec) => rec.value === parseInt(ret[i])
        )?.label
      }
      return ret.join()
    },
    async changeRole(role) {
      this.$loading({
        text: '角色权限更新中'
      })
      role.menu = role.menus.join()
      role.dashboardModule = role.dashboard.join()
      let ret = await brequest({
        url: '/user/updateRoleInfo',
        data: role
      })
      this.$loading().close()
      if (ret) {
        this.editState = false
        this.$message({
          message: '角色权限更新成功',
          type: 'success'
        })
        let nrole = this.allRoles.find((rec) => rec.id === role.id)
        nrole.accessResource = role.accessResource
        nrole.menu = role.menu
        nrole.menus = role.menus
        nrole.dashboardModule = role.dashboardModule
        nrole.dashboard = role.dashboard
        nrole.menuTxt = this.queryMenuName(role.menu)
        nrole.dashboardTxt = this.queryDashboardName(role.dashboardModule)
      }
    }
  },
  data() {
    return {
      // 编辑表单数据
      editState: false,
      editRole: {},
      // 筛选模型
      params: {
        uname: '',
        // date: [],
        pagenum: 1
      },
      // 表格列
      columns: [
        { title: '角色名', field: 'roleName' },
        // { title: '接口权限', field: 'accessResource' },
        { title: '菜单权限', field: 'menuTxt' },
        // { title: '仪表盘权限', field: 'dashboardTxt' },
        {
          title: '操作',
          width: '160',
          type: 'btn',
          payload: [
            {
              name: '编辑',
              type: 'primary',
              click: (row) => {
                console.log('修改', row)
                this.editRole = JSON.parse(JSON.stringify(row))
                // 1 显示弹框
                this.editState = true
                // 2.
              }
            },
            {
              name: '删除',
              type: 'danger',
              click: (row) => this.deleteFn(row)
            }
          ]
        }
      ],
      // 表格数据
      menus: [],
      allRoles: []
    }
  },
  async mounted() {
    await this.queryAllMenus()
    this.queryAllRoles()
  }
}
</script>

<style lang="scss" scoped>
// history
// .history {
// }
</style>
